exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".drop-down-container span.short-name,.selected-item span.short-name{font-size:small;font-weight:500}.drop-down-container span.full-address,.drop-down-container span.full-name,.selected-item span.full-address,.selected-item span.full-name{font-size:small}", "", {"version":3,"sources":["/home/kif/ZF/GeCoo/GeCoo/ClientApp/src/components/Clinic/ClinicSelect.css"],"names":[],"mappings":"AAAA,oEAEI,gBAAiB,AACjB,eAAiB,CACpB,AAED,0IAII,eAAiB,CACpB","file":"ClinicSelect.css","sourcesContent":[".selected-item span.short-name,\n.drop-down-container span.short-name {\n    font-size: small;\n    font-weight: 500;\n}\n\n.selected-item span.full-name,\n.selected-item span.full-address,\n.drop-down-container span.full-name,\n.drop-down-container span.full-address {\n    font-size: small;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Clinic/ClinicSelect.css
// module id = 574
// module chunks = 0 1